import { graphql } from '@/client/services/api/graphql/gql';

export const createAnnouncementMutation = graphql(`
  mutation CreateAppAnnouncement($input: AppAnnouncementCreateInput!) {
    createAppAnnouncement(input: $input) {
      id
      title
      content
      routes
      published
      publishedAt
      createdAt
    }
  }
`);
